(function () {
  const shopRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function isAddToCartForm(el) {
    return el?.tagName === 'FORM' && /\/cart\/add(\.js)?$/.test(el.getAttribute('action') || '/cart/add');
  }

  function openDrawer() {
    const dawnDrawer = document.querySelector('cart-drawer');
    if (dawnDrawer && typeof dawnDrawer.open === 'function') {
      dawnDrawer.open();
      return;
    }
    const drawer = document.querySelector('.drawer');
    const inner  = document.querySelector('.drawer__inner');
    if (drawer && inner) {
      drawer.classList.add('active');
      inner.style.transform = 'translateX(0)';
      drawer.setAttribute('aria-hidden', 'false');
      drawer.addEventListener('click', (e) => {
        if (e.target === drawer) {
          drawer.classList.remove('active');
          inner.style.transform = 'translateX(100%)';
          drawer.setAttribute('aria-hidden', 'true');
        }
      }, { once: true });
    }
  }

  async function refreshDrawerSections() {
    try {
      const url = `${shopRoot}?sections=cart-drawer,cart-icon-bubble&ts=${Date.now()}`;
      const res = await fetch(url, {
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { 'Cache-Control': 'no-store' }
      });
      if (!res.ok) return;
      const sections = await res.json();

      const dawnDrawer = document.querySelector('cart-drawer');
      if (dawnDrawer && sections['cart-drawer']) {
        if (typeof dawnDrawer.renderContents === 'function') {
          dawnDrawer.renderContents(sections['cart-drawer']);
        } else {
          dawnDrawer.outerHTML = sections['cart-drawer'];
        }
      }

      const bubble = document.getElementById('cart-icon-bubble');
      if (bubble && sections['cart-icon-bubble']) {
        bubble.outerHTML = sections['cart-icon-bubble'];
      }

      const customTarget = document.querySelector('[data-cart-drawer]');
      if (customTarget && sections['cart-drawer']) {
        customTarget.innerHTML = sections['cart-drawer'];
      }
    } catch (e) {
      // Drawer refresh failed silently
    }
  }

  async function addToCartViaAjax(form) {
    const fd = new FormData(form);

    // Ensure quantity is present (some themes render the quantity input outside the form using the `form` attribute)
    // Always prefer the visible quantity selector value
    {
      let qtyInput = form.querySelector('input[name="quantity"]');
      if (!qtyInput && form.id) {
        qtyInput = document.querySelector(`input[name="quantity"][form="${CSS.escape(form.id)}"]`);
      }
      if (!qtyInput) {
        const section = form.closest('.shopify-section') || document;
        qtyInput = section.querySelector('input[name="quantity"]');
      }
      if (qtyInput) {
        const val = parseInt(qtyInput.value, 10);
        fd.set('quantity', isNaN(val) || val <= 0 ? 1 : val);
      }
    }
    
    // Don't request sections in the POST - we'll fetch them separately with proper cache-busting
    const endpoint = form.getAttribute('action')?.endsWith('.js')
      ? form.getAttribute('action')
      : `${shopRoot}cart/add.js`;

    const res = await fetch(endpoint, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: fd,
      credentials: 'same-origin',
      cache: 'no-store'
    });

    if (!res.ok) {
      let message = 'Unable to add to cart.';
      try {
        const err = await res.json();
        if (err && (err.description || err.message)) {
          message = err.description || err.message;
        }
      } catch (_) {}
      alert(message);
      return false;
    }

    // Item successfully added - now fetch the updated cart drawer section
    try {
      const ts = Date.now();
      
      // Fetch cart-drawer section directly from /cart with section_id parameter
      const drawerUrl = `${shopRoot.replace(/\/$/, '')}/cart?section_id=cart-drawer&ts=${ts}`;
      const drawerRes = await fetch(drawerUrl, {
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { 
          'Cache-Control': 'no-store',
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      if (!drawerRes.ok) {
        throw new Error('Failed to fetch cart drawer');
      }

      const drawerHTML = await drawerRes.text();
      
      // Parse the section HTML and extract the cart drawer content
      const parser = new DOMParser();
      const doc = parser.parseFromString(drawerHTML, 'text/html');
      
      // The response should contain a .shopify-section wrapper with cart-drawer inside
      const sectionWrapper = doc.querySelector('.shopify-section') || doc.body;
      const newCartDrawer = sectionWrapper.querySelector('cart-drawer');
      
      if (newCartDrawer) {
        // Replace the entire cart-drawer element
        const currentCartDrawer = document.querySelector('cart-drawer');
        if (currentCartDrawer) {
          currentCartDrawer.outerHTML = newCartDrawer.outerHTML;
          
          // Wait for the new element to be in DOM
          await new Promise((r) => requestAnimationFrame(r));
          
          // Get the newly inserted cart-drawer and open it
          const freshDrawer = document.querySelector('cart-drawer');
          if (freshDrawer && typeof freshDrawer.open === 'function') {
            freshDrawer.open();
          }
        }
      }
      
      // Also update the cart icon bubble
      const bubbleUrl = `${shopRoot}?section_id=cart-icon-bubble&ts=${ts}`;
      const bubbleRes = await fetch(bubbleUrl, {
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { 
          'Cache-Control': 'no-store',
          'X-Requested-With': 'XMLHttpRequest'
        }
      });
      
      if (bubbleRes.ok) {
        const bubbleHTML = await bubbleRes.text();
        const bubbleDoc = parser.parseFromString(bubbleHTML, 'text/html');
        const bubbleSection = bubbleDoc.querySelector('.shopify-section') || bubbleDoc.body;
        const bubbleContent = bubbleSection.innerHTML;
        
        const bubble = document.getElementById('cart-icon-bubble');
        if (bubble) {
          bubble.innerHTML = bubbleContent;
        }
      }
      
    } catch (err) {
      
      // Fallback: try the old refresh method
      await refreshDrawerSections();
      await new Promise((r) => requestAnimationFrame(r));
      openDrawer();
    }

    return true;
  }

  document.addEventListener('submit', async (e) => {
    const form = e.target;
    if (!isAddToCartForm(form)) return;
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
    try {
      await addToCartViaAjax(form);
    } finally {
      if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); }
    }
  }, true);

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-ajax-add-to-cart]');
    if (!btn) return;
    const form = btn.closest('form');
    if (!form || !isAddToCartForm(form)) return;
    e.preventDefault();
    form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
  });
})();

